import makeStyles from '@mui/styles/makeStyles';
import { memo, useMemo } from "react";
import theme from "../../../theme";
import GridViewEntryListItem from "./GridViewEntryListItem";
import MasonryList from "../../../Utils/MasonryList";

const useStyles = makeStyles(theme => ({    
    masonryGrid: {
        margin: theme.spacing(3),
    },
    masonryGridColumn: {
    },
    masonryGridItem: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1)
        },
    },
}));

export default memo(function LargeGridViewList({ linkComponent, entriesData, }) {

    const classes = useStyles();

    // turn the array of sub-arrays into object that masonry plugin understands
    const masonryBreakpointCols = useMemo(() => {
        // map of masonry columns we want for each MUI breakpoint name
        const muiMasonryBreakpointColCounts = {
            xs: 2,
            sm: 2,
            md: 3,
            lg: 4,
            xl: 6,
        };
        // the Masonry plugin does breakpoints in the format { <breakpoint-size-in-pixels>: <num-columns> }
        // so we need to translate the breakpoint size names to the pixel breakpoint sizes from the theme.
        const muiBreakpointKeys = Object.keys(muiMasonryBreakpointColCounts);
        // create an array of sub arrays in the format [<breakpoint-size-or-default>: <num-columns>], which can be convert to object with fromEntries.
        const masonryBreakpointColData = muiBreakpointKeys
            .map((breakpointKey, i) => {
                // MUI sizes are bottom up, but the masonry plugin is top down, so we need to associate the number of columns with the next size up
                const nextBreakpointKey = muiBreakpointKeys[i + 1];
                // the top size the plugin uses is called "default"
                return [theme.breakpoints.values[nextBreakpointKey] ?? "default", muiMasonryBreakpointColCounts[breakpointKey]]
            });

        return Object.fromEntries(masonryBreakpointColData);
    }, []);
    
    const EntryComponent = useMemo(() => memo(function EntryComponent({ item: entryData }) {
        return (
            <div id={`e${entryData.entry.id}`}>
                {/* <RenderIfVisible estimatedHeight="600px"> */}
                    <GridViewEntryListItem 
                        entry={entryData.entry}
                        categoryId={entryData.category?.id}
                        categoryName={entryData.category?.title}
                        linkComponent={linkComponent}
                    />
                {/* </RenderIfVisible> */}
            </div>
        )
    }), [linkComponent]);

    return (
        <>
            <MasonryList
                data={entriesData}
                defaultCols={6}
                breakpointCols={masonryBreakpointCols}
                className={classes.masonryGrid}
                columnClassName={classes.masonryGridColumn}
                itemComponent={EntryComponent}
            />
        </>
    );
});